import { createAction } from '@reduxjs/toolkit';
import { setProPayloadT } from 'Store/Actions/ts/index';
import cart from 'Store/contentState/cartBoqSlice'
// import { setProPayloadT } from './ts';
export const setProp = createAction<setProPayloadT>('setProp');
export const addCartItem = createAction('cartBoq/addCartItem');
export const updateCartItem = createAction('cartBoq/updateCartItem');
export const removeCartItem = createAction('cartBoq/removeCartItem');
